import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import draggable from 'vuedraggable'

export default {
  name: 'ServiceContentsApplySortModal',
  components: {
    Loading,
    draggable
  },
  data () {
    return {
      loading: true,
      processing: false,

      // // テーブルオプション
      // tableColumns: [
      //   'checkbox',
      //   'priorityOrder',
      //   'appliedContentsId',
      //   'deliveryToKbn',
      //   'serviceContentsId',
      //   'snapshotName',
      //   'deviceType',
      // ],
      // tableData: [],
      // tableOptions: {
      //   headings: {
      //     checkbox: '',
      //     priorityOrder: '優先順位',
      //     appliedContentsId: '適用コンテンツID',
      //     deliveryToKbn: '配信先',
      //     serviceContentsId: 'コンテンツID',
      //     snapshotName: 'スナップショット名',
      //     deviceType: '対象デバイス',
      //   },
      //   columnsClasses: {
      //     checkbox: 'wp-3',
      //     priorityOrder: '',
      //     appliedContentsId: 'wp-5',
      //     deliveryToKbn: '',
      //     serviceContentsId: '',
      //     snapshotName: '',
      //     deviceType: '',
      //   },
      //   sortable: [],
      //   filterable: [],
      //   texts: Constants.TableOptions.getTexts('適用コンテンツ'),
      //   perPage: 99999,
      // },

      dragModel: [],
      dragInit: true, // 不要イベント対応
      draggableOptions: {
        draggable: '.item',
        filter: '.ignore'
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.serviceContentsApplySortModal.active,
      serviceId: state => state.serviceContentsApplySortModal.serviceId,
      serviceContentsId: state => state.serviceContentsApplySortModal.serviceContentsId,

      // model
      contentsApplyModel: state => state.serviceContentsApplySortModal.contentsApplyModel,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({

    }),

    deliveryToKbn(value) {
      return value => {
        return Utility.getConstantsLabel(['ContentsApply', 'DeliveryToKbn'], value)
      }
    },

    // disabled
    disableConfirmButton () {
      return false
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'submit') {
        if (to) this.postData()
      }
    },
    dragModel (to) {
      // const index = this.dragModel.indexOf(undefined)
      // if (index !== -1) {
      //   this.dragModel.splice(index, 1);
      // }
      this.dragModel.forEach((item, index) => {
        item.priorityOrder = index + 1
      })
      this.dragInit = true;
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceContentsApplySortModal/loadModel',
      hide: 'serviceContentsApplySortModal/hide',
      setUpdated: 'serviceContentsApplySortModal/setUpdated'
    }),
    ...mapMutations({
      setInputValue: 'serviceContentsApplySortModal/setInputValue',
    }),

    onMoved (evt) {
      // 変なイベントが発生するマウス対策
      if (this.dragInit && evt.originalEvent.fromElement === null) {
        this.dragInit = false
        return false
      }
      // 「index=0」はヘッダーなので、一番上にはドラッグできないようにする
      // return evt.relatedContext.index !== 0
    },

    init () {
      this.loading = true

      // データ更新フラグの初期化
      this.setUpdated(false)

      //
      let contentsApplyParams = {
        serviceUuid: this.serviceId
      }
      if (this.searchContents) {
        contentsApplyParams.filters = {
          serviceContentsUuid: this.searchContents
        }
      }

      // データ読出し
      this.loadModel({
        contentsApplyParams: contentsApplyParams,
      })
        // eslint-disable-next-line
        .then(res => {
          // this.tableData = $.extend(true, [], this.contentsApplyModel)
          this.$set(this, 'dragModel', $.extend(true, [], this.contentsApplyModel))
          this.dragInit = true

          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    // getViewData (props) {
    //   let key = props.column
    //   let value = props.row[key]

    //   switch (key) {
    //     case 'deliveryToKbn':
    //       return Utility.getConstantsLabel(['ContentsApply', 'DeliveryToKbn'], value)
    //   }
    //   return value
    // },

    confirmData () {
      this.showConfirm({
        key: 'submit',
        title: '',
        body: '優先順位を変更しますか？',
        acceptLabel: '変更'
      })
    },
    postData () {
      console.log('check : ', this.checkList)

      this.processing = true

      let parameters = {
        serviceUuid: this.serviceId,
        request: {
          appliedContentsPriorities: this.dragModel
            .map(item => {
              return {
                appliedContentsUuid: item.appliedContentsUuid,
                priorityOrder: item.priorityOrder
              }
            })
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceContentsApply'],
        ['v1ServiceContentsApplyOrderPatch'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '優先順位の変更',
              body: '優先順位を変更しました。'
            })

            // データ更新フラグを有効
            // 呼び出し元のページで一覧を更新するため
            this.setUpdated(true)

            this.closeModal()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}